import loadingReducer from "../connected-components/loader/reducer";
import enquireModalReducer from "../connected-components/enquireModal/reducer";
import configReducer from "../config/reducer";

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  loading: loadingReducer,
  enquireModal: enquireModalReducer,
  config: configReducer,
};
